import { createRequestActions } from '../utils';
import * as orderItemProductTypes from './orderItemProductTypes';

export const submitOrdersItemsProducts = createRequestActions(
  orderItemProductTypes.SUBMIT,
  payload => payload,
  (data, meta) => meta,
);
